import "./BathroomRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Included from "./sections/Included";
import BathroomProjectCtaBand from "./sections/BathroomProjectCtaBand";
import BathroomGallery from "./sections/BathroomGallery";
import Planning from "./sections/Planning";
import Questions from "./sections/Questions";
import Action from "./sections/Action";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function BathroomRemodelingPage() {
  return <div>
      <Header />
      <Hero />
      <Included />
      <BathroomProjectCtaBand />
      <BathroomGallery />
      <Planning />
      <Questions />
      <EstimateRequestForm />
      <Action />
      <Footer />
    </div>;
}